function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#d6e8fd}.cls-2{fill:var(--violet-blue)}.cls-5{fill:#fed943}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3232",
  "data-name": "Group 3232"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4274",
  d: "M128.844 59.131h-7.964a20.478 20.478 0 0 0-31.636-25.66l-1.834 1.835v-10a25.309 25.309 0 1 0-50.618 0V36.29h-4.215a32.577 32.577 0 0 0 0 65.154h96.267a21.156 21.156 0 0 0 0-42.313z",
  className: "cls-1",
  "data-name": "Path 4274"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4275",
  d: "M279.169 59.142h-7.963a20.478 20.478 0 0 0-31.636-25.66l-1.835 1.835v-10a25.307 25.307 0 0 0-25.12-25.3v101.438h66.554a21.156 21.156 0 1 0 0-42.313z",
  className: "cls-1",
  "data-name": "Path 4275",
  transform: "translate(-150.325 -.011)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4276",
  d: "M66.851 192.112a15.489 15.489 0 0 0-1.567-.087 14.841 14.841 0 0 0-12.985 7.5l-34.372 59.531a14.994 14.994 0 0 0 12.985 22.491h35.939z",
  className: "cls-2",
  "data-name": "Path 4276",
  transform: "translate(-11.238 -135.768)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3233",
  "data-name": "Group 3233",
  transform: "translate(54.047 56.257)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4277",
  d: "M231.836 259.056l-34.372-59.534a14.842 14.842 0 0 0-12.985-7.5v89.522h34.372a14.994 14.994 0 0 0 12.985-22.491z",
  className: "cls-2",
  "data-name": "Path 4277",
  transform: "translate(-184.479 -192.025)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3235",
  "data-name": "Group 3235",
  transform: "translate(0 52.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3234",
  "data-name": "Group 3234"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4278",
  fill: "#411cff",
  d: "M55.033 266.78h-38.6a7.605 7.605 0 0 1-6.586-11.408l37.613-65.147a7.527 7.527 0 0 1 6.586-3.8 7.838 7.838 0 0 1 .986.063v-8.838c-.327-.019-.655-.03-.986-.03a16.242 16.242 0 0 0-14.209 8.2L2.225 250.971a16.408 16.408 0 0 0 14.209 24.612h38.6z",
  "data-name": "Path 4278",
  transform: "translate(-.001 -177.62)"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3236",
  "data-name": "Group 3236",
  transform: "translate(54.047 52.037)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4279",
  fill: "#431ffb",
  d: "M236.3 250.971l-37.613-65.147a16.242 16.242 0 0 0-14.21-8.2v8.8a7.528 7.528 0 0 1 6.586 3.8l37.613 65.147a7.605 7.605 0 0 1-6.586 11.408h-37.611v8.8h37.613a16.408 16.408 0 0 0 14.21-24.612z",
  "data-name": "Path 4279",
  transform: "translate(-184.479 -177.62)"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3237",
  "data-name": "Group 3237",
  transform: "translate(49.581 87.615)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4280",
  d: "M171.751 325.079v-26.021h-5.345l1.765 26.021z",
  className: "cls-5",
  "data-name": "Path 4280",
  transform: "translate(-166.235 -299.058)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4281",
  d: "M171.338 410.677h-.05c-3.188 0-5.466 2.164-5.466 5.068a5.234 5.234 0 0 0 5.466 5.181h.05z",
  className: "cls-5",
  "data-name": "Path 4281",
  transform: "translate(-165.822 -377.975)"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3238",
  "data-name": "Group 3238",
  transform: "translate(54.047 87.615)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4282",
  d: "M189.774 299.058h-5.3v26.021h3.531z",
  className: "cls-5",
  "data-name": "Path 4282",
  transform: "translate(-184.479 -299.058)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4283",
  d: "M189.946 415.743c0-2.9-2.278-5.068-5.466-5.068v10.249a5.234 5.234 0 0 0 5.466-5.181z",
  className: "cls-5",
  "data-name": "Path 4283",
  transform: "translate(-184.48 -377.975)"
}));

var SvgAccessDenied = function SvgAccessDenied(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "access-denied",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccessDenied, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/access-denied.c9d1efbb.svg";
export { ForwardRef as ReactComponent };